var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "es_time",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3548 12.3537H3.27436C3.24769 12.3537 3.22159 12.3513 3.19624 12.3468C2.70392 12.3279 2.24308 12.1301 1.89174 11.7854C1.51725 11.4079 1.3125 10.9156 1.3125 10.3941V6.16498C1.3125 5.76946 1.50675 5.41597 1.83224 5.2188C2.13499 5.03563 2.50365 5.02397 2.81807 5.1873L3.19898 5.38622C3.30515 5.44105 3.43115 5.4463 3.55364 5.3938L4.2688 5.0718C4.29812 5.05933 4.32732 5.04983 4.35643 5.043V3.07936C4.35643 2.6862 4.55068 2.3327 4.87501 2.13378C5.17717 1.94887 5.5435 1.93487 5.8579 2.09412L6.24698 2.30353C6.34732 2.3537 6.47156 2.3572 6.58706 2.30587L7.66505 1.82754C8.21921 1.58662 8.82646 1.58604 9.37653 1.82637L10.4557 2.30528C10.5706 2.35603 10.6949 2.35487 10.8045 2.29887L11.1773 2.09878C11.501 1.9337 11.8679 1.94712 12.1701 2.1332C12.4944 2.33095 12.6875 2.68503 12.6875 3.07936L12.6823 9.77013C12.6823 11.3638 11.7903 12.3537 10.3548 12.3537ZM4.35643 5.99138L3.90131 6.19648C3.53439 6.35048 3.13598 6.33706 2.79707 6.16323L2.41324 5.96315C2.39807 5.95498 2.34849 5.92873 2.28549 5.96723C2.26274 5.98123 2.18749 6.03606 2.18749 6.16498V10.3941C2.18749 10.6823 2.30124 10.9564 2.5089 11.1647C2.70957 11.3619 2.98315 11.4733 3.27423 11.4733C3.29411 11.4733 3.31368 11.4746 3.33285 11.4772C3.90198 11.4466 4.35643 10.9725 4.35643 10.3943V5.99138Z",
    fill: "url(#paint0_linear_3180_30146)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89507 6.05935H6.95447C6.65724 6.05935 6.41602 5.81812 6.41602 5.52088C6.41602 5.22365 6.65724 4.98242 6.95447 4.98242H8.89507C9.1923 4.98242 9.43352 5.22365 9.43352 5.52088C9.43352 5.81812 9.1923 6.05935 8.89507 6.05935ZM10.7567 9.01657H6.95447C6.65724 9.01657 6.41602 8.77534 6.41602 8.47811C6.41602 8.18088 6.65724 7.93965 6.95447 7.93965H10.7567C11.0539 7.93965 11.2951 8.18088 11.2951 8.47811C11.2951 8.77534 11.0539 9.01657 10.7567 9.01657Z",
    fill: "url(#paint1_linear_3180_30146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3180_30146",
    x1: 1.3125,
    y1: 1.64648,
    x2: 1.3125,
    y2: 12.3537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3180_30146",
    x1: 6.41602,
    y1: 4.98242,
    x2: 6.41602,
    y2: 9.01657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReceipt);
export default __webpack_public_path__ + "static/media/ic_receipt.3c37354d.svg";
export { ForwardRef as ReactComponent };